import { createContext, ReactNode, useContext, useReducer } from "react";
import { InitialContext } from "../../../../types/state/context";
import { CreateMpnReducer } from "../../states/create";
import {
  CreateMpnActionTypes,
  CreateMpnState,
} from "../../states/create/data";

type Context = InitialContext<CreateMpnState, CreateMpnActionTypes>;
export const MpnCreateContext = createContext<Context>({} as Context);

export const MpnCreateProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(
    CreateMpnReducer.reducer,
    CreateMpnReducer.initialState,
  );

  return (
    <MpnCreateContext.Provider value={{ state, dispatch }}>
      {children}
    </MpnCreateContext.Provider>
  );
};

export const useCreateMpnStore = () => useContext(MpnCreateContext);
